module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info"
  }, [(_vm.isCaruselData) ? _c('Slider', {
    attrs: {
      "items": _vm.caruselData
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var info = ref.data.info;

        return _vm._l((info), function(ref, index) {
          var date = ref.date;
          var items = ref.items;
          var noFormatDate = ref.noFormatDate;

          return _c('Card', {
            key: index,
            attrs: {
              "id": _vm.id,
              "date": date,
              "items": items,
              "noborder": _vm.noborder,
              "noFormatDate": noFormatDate,
              "show-addition": _vm.showAddition
            }
          })
        })
      }
    }], null, false, 176431967)
  }) : _vm._l((_vm.info), function(ref, index) {
    var date = ref.date;
    var items = ref.items;
    var noFormatDate = ref.noFormatDate;

    return _c('Card', {
      key: index,
      attrs: {
        "id": _vm.id,
        "date": date,
        "items": items,
        "noborder": _vm.noborder,
        "noFormatDate": noFormatDate,
        "show-addition": _vm.showAddition
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02797ea4","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/info/Info.vue
// module id = b8c1e46e7ca015f720c8
// module chunks = 89